import { SET_FA_WARN_MSG } from "../../actions/action.types";

const FAWarnMsg = (state = "", action: any) => {
  if (action.type === SET_FA_WARN_MSG) return action.payload;
  else return state;
};

export default FAWarnMsg;
